export enum EHarvestSaleMultiLotsApiUrl {
  createMultiRequest = '/api/async/multirequests',
  multiRequestWithId = '/api/multirequests',
  saleRequestChat = '/api/multirequests/:requestId/chat',
  saleRequestNextStatus = '/api/multirequests/:requestId/status/next',
  saleRequestWithId = '/api/multirequests/:requestId',
  saleRequestHistory = '/api/multirequests/:requestId/history',
}
